module.exports = __webpack_public_path__ + "static/media/heart.72b003d3.svg";